import { combineReducers } from 'redux'
import cart from 'base/reducers/cart'
import factories from 'base/reducers/factories'
import user from 'base/reducers/session/user'
import visitor from 'base/reducers/session/visitor'
import addresses from 'base/reducers/session/addresses'
import creditCards from 'base/reducers/session/creditCards'
import emailSubscription from 'base/reducers/session/email_subscription'
import deviceFingerprint from 'base/reducers/session/device_fingerprint'
import messaging from 'base/reducers/session/messaging'
import pathHistory from 'base/reducers/pathHistory'
import orderPreview from 'base/reducers/checkout/orderPreview'
import giftForm from 'base/reducers/checkout/giftForm'
import shippingOptions from 'base/reducers/checkout/shippingOptions'
import paymentMethod from 'base/reducers/checkout/paymentMethod'
import braintreeToken from 'base/reducers/checkout/braintreeToken'
import guest from 'base/reducers/checkout/guest'
import userSelections from 'base/reducers/checkout/userSelections'
import shippingConstants from 'base/reducers/shipping_constants'
import activeRequests from 'base/reducers/activeRequests'
import orders from 'base/reducers/orders'
import collections from 'base/reducers/collections'
import pdpCollections from 'base/reducers/pdpCollections'
import products from 'base/reducers/products'
import searchResults from 'base/reducers/searchResults'
import returnAuthorizations from 'base/reducers/returns/returnAuthorizations'
import waitlist from 'base/reducers/waitlist'
import menus from 'base/reducers/menus'
import modal from 'base/reducers/modals'
import modelSize from 'base/reducers/modelSize'
import navigation from 'base/reducers/navigation'
import pdp from 'base/reducers/pdp'
import pages from 'base/reducers/pages'
import filters from 'base/reducers/filters'
import regions from 'base/reducers/regions'
import productPrices from 'base/reducers/productPrices'
import appConfig from 'base/reducers/appConfig'
import upsellProducts from 'base/reducers/upsellProducts'
import receiveLineItem from 'base/reducers/receiveLineItem'
import flyoutCart from 'base/reducers/flyoutCart'

const rootReducer = combineReducers({
  pathHistory,
  activeRequests,
  cart,
  factories,
  waitlist,
  orders,
  collections,
  pdpCollections,
  products,
  productPrices,
  menus,
  modal,
  modelSize,
  navigation,
  pdp,
  pages,
  filters,
  regions,
  flyoutCart,
  shippingConstants,
  appConfig,
  receiveLineItem,
  returns: combineReducers({
    returnAuthorizations,
  }),
  searchResults,
  checkout: combineReducers({
    orderPreview,
    shippingOptions,
    paymentMethod,
    braintreeToken,
    guest,
    userSelections,
    giftForm,
    upsellProducts,
  }),
  session: combineReducers({
    user,
    visitor,
    messaging,
    creditCards,
    addresses,
    emailSubscription,
    deviceFingerprint,
  }),
})

export default rootReducer
